import { FC } from "react";

const OtherTextField: FC<{
  label: string;
  showError: boolean;
  errorLabel: string;
  handleChange: (event: React.FormEvent<HTMLInputElement>) => void;
  value: string;
  setValue: Function;
}> = ({ label, showError, errorLabel, handleChange, value, setValue }) => {
  return (
    <input
      type="text"
      placeholder={label}
      className="block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
      value={value}
      onChange={handleChange}
    />
  );
};

export { OtherTextField };
